/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { BaseFinalCommand } from "namirasoft-node-cli";
import { NamirasoftAPIWorkServer } from "../NamirasoftAPIWorkServer";

export class WorkListCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, ["filters", "page", "size", "sorts"], []);
    }
    override async exec()
    {
        let url = this.app.storage.getItem("ns-api-work-server-url");
        let server = new NamirasoftAPIWorkServer(url, e => this.app.logger.error(e.message));
        let ans = await server.work.List(this.arg_values[0], this.arg_values[1], this.arg_values[2], this.arg_values[3]);
        this.app.logger.success(JSON.stringify(ans));
    }
};